import { DefaultTheme } from 'styled-components';

const defaultTheme: DefaultTheme = {
  borderRadius: '5px',

  colors: {
    primary: '#642163',
    secondary: '#3ECFFE',
  },
};

export default defaultTheme;
